import { DEFAULT_PRIVACY_CONTACT_EMAIL } from '@digitaltattoo/shared-utils';

const siteOrigin = typeof window !== 'undefined' ? window.location.origin : '';

/** Legal URLs — override via VITE_* at build time. */
export const legalConfig = {
  privacyPolicyUrl: import.meta.env.VITE_PRIVACY_POLICY_URL || `${siteOrigin}/legal/privacy`,
  termsUrl: import.meta.env.VITE_TERMS_URL || `${siteOrigin}/legal/terms`,
  cookiesUrl: import.meta.env.VITE_COOKIES_URL || `${siteOrigin}/legal/cookies`,
  privacyContactEmail: import.meta.env.VITE_PRIVACY_CONTACT_EMAIL || DEFAULT_PRIVACY_CONTACT_EMAIL,
};
